var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.02 4.03l-.99.99L6.01 7 4.03 8.98l.99.99L7 7.99l1.98 1.98.99-.99L7.99 7l1.98-1.98-.99-.99L7 6.01zM1.4 7a5.6 5.6 0 1111.2 0A5.6 5.6 0 011.4 7zM14 7A7 7 0 100 7a7 7 0 0014 0z"
  })));
}
export default __webpack_public_path__ + "static/svg/round-x.svg";
export { SvgRoundX as ReactComponent };